@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';
@import '~less/layout/helpers';

.profile-view {
  padding-bottom: 0;
  padding-top: @navbar-height;
  @media (min-width: @screen-sm-min) {
    padding-top: 0;
  }
}

.profile-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;

  > li {
    float: none;
    margin: 0;

    > a,
    > button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin: 0;
      padding: 10px 0;
      line-height: 1.4;
      text-align: left;
      white-space: nowrap;

      > i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1em;
      }
    }
  }
}

@media (max-width: @screen-xs-max) {
  .profile-view-navbar-mobile {
    .navbar-nav {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 100%;
      overflow-x: auto;
    }

    .navbar-nav > li {
      flex: 1 0 auto;
      text-align: center;

      > a,
      > a:hover,
      > a:focus {
        color: @navbar-default-link-color;
        padding: 10px 4px;
      }

      &.active > a {
        color: @navbar-default-link-active-color;
        background: @navbar-default-link-active-bg;
      }
    }
  }
}

.profile-flags {
  padding-bottom: 40px;
}

.profile-tabs {
  margin-top: @padding-base-horizontal;
  .nav {
    a {
      .cursor-pointer;
    }
    .disabled a {
      cursor: default;
    }
  }
}

.profile-name,
.profile-username {
  display: inline-block;
  margin: 0;
  padding: 0;
  padding-bottom: 10px;
  word-wrap: break-word;
}

.profile-name {
  margin-top: 20px;
  @media (min-width: @screen-sm-min) {
    margin: 0 10px 5px 0;
  }
}

.profile-tagline {
  font-size: 17px;
  font-weight: 200;
  line-height: 1.4;
  word-wrap: break-word;
  @media (min-width: @screen-sm-min) {
    font-size: 17px;
    padding-bottom: 10px;
  }
}

.profile-quote {
  display: block;
  .center-block();
  width: 80%;
  .text-muted();
  text-align: center;
  font-family: @font-family-serif;
  font-style: italic;
  font-size: 18px;
  padding: 0;
  border: 0;
}

// Toggling avatar bigger at mobile screens
@media (max-width: @screen-xs-max) {
  .avatar {
    max-width: 256px;
    max-height: 256px;
  }
  .profile-avatar-lg .avatar {
    width: 100%;
    height: auto;
    max-width: none;
    max-height: none;
  }
}

// Keep the enlarged photo centred and within the viewport, including short screens.
.modal-avatar {
  .modal-dialog {
    width: min(514px, calc(100vw - 32px), calc(100vh - 64px));
    max-width: none;
    margin: 32px auto;
  }

  .modal-content {
    padding: 0;

    .avatar {
      display: block;
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: none;
      cursor: zoom-out;
    }
  }
}

.profile-overview {
  @media (min-width: @screen-sm-min) {
    max-width: 256px;
  }
  h4,
  /* Labels occur when editing profile... */
  .control-label {
    .text-muted();
    text-transform: uppercase;
    margin: 3px 0 0 0;
  }
  &, h4,
  /* Labels occur when editing profile... */
  .control-label {
    font-size: 13px;
    line-height: 20px;
    font-weight: normal;
  }
  .avatar {
    .img-responsive;
    border-top-left-radius: @panel-border-radius;
    border-top-right-radius: @panel-border-radius;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    cursor: zoom-in;
  }
  .profile-photo-edit-link .avatar {
    cursor: pointer;
  }
  .profile-sidebar-section {
    margin: 0 0 @padding-small-horizontal 0;
    padding: 0 0 @padding-small-horizontal 0;
    border-bottom: 1px solid @gray-lighter;
    &:last-child {
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}

// "Tribes in common" directive
.profile-tribes-common {
  h4 {
    color: @gray-light;
    text-transform: uppercase;
    margin: 3px 0 0 0;
    font-size: @font-size-base;
    line-height: 20px;
    font-weight: normal;
  }
  a {
    color: @text-color;
  }
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid @gray-lighter;
}

// List of social accounts
.elsewhere-profiles {
  margin-top: 5px;
  margin-bottom: 10px;
  .social-profile-icon {
    speak: none;
    color: @gray-light;
    margin-left: -34px;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }
  .nostroots-logo {
    width: 22px;
    height: 22px;
    margin-top: -3px;
    margin-bottom: -3px;
    object-fit: contain;
  }
  .social-profile {
    padding: 4px 4px 4px 34px;
    margin: 0;

    &.social-profile-connect {
      line-height: 33px;
    }

    .social-profile-handle {
      background: transparent;
    }

    &:hover,
    &.social-profile-active {
      .social-profile-icon {
        color: @brand-primary;
        filter: none;
        -webkit-filter: none;
        // Here's a good list of these:
        // @link https://www.competethemes.com/social-media-colors/
        &.icon-twitter {
          color: #00aced;
        }
        &.icon-github {
          color: #333;
        }
        &.icon-warmshowers {
          color: #007071;
        }
      }
    }
  }
}

// Profile Nostroots Badge
.profile-nostr-badge {
  display: inline-block;
  background: @brand-primary;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 8px;
  vertical-align: middle;
}

// Profile Nostroots Notes
.profile-nostr-notes {
  margin-top: @padding-large-horizontal;
}

.profile-nostr-notes-title {
  font-weight: 600;
  font-size: 13px;
  color: @gray;
  margin-bottom: @padding-base-horizontal;
}

.profile-nostr-note {
  background: @gray-lighter;
  border-left: 3px solid @brand-primary;
  padding: @padding-small-horizontal @padding-base-horizontal;
  border-radius: 0 @border-radius-base @border-radius-base 0;
  margin-bottom: 8px;
  transition: background-color 0.15s ease-out;

  &:hover {
    background: darken(@gray-lighter, 3%);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.profile-nostr-note-content {
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  word-wrap: break-word;
}

.profile-nostr-note-meta {
  font-size: 11px;
  margin-top: 4px;
  display: block;
}

.profile-nostr-notes-more {
  font-size: 13px;
  display: inline-block;
  margin-top: 8px;
  color: @brand-secondary;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.15s ease-out;

  &:hover {
    color: darken(@brand-secondary, 15%);
  }
}
